import GenericTransition from '../../common/generic-transition'
import PACKAGE_COMPONENT_PREFIX from '../../common/config'

let single = new GenericTransition(PACKAGE_COMPONENT_PREFIX + 'bounce', 'bounce')
let group = new GenericTransition(PACKAGE_COMPONENT_PREFIX + 'group-bounce', 'bounce', undefined, true)

export default {single, group}



// WEBPACK FOOTER //
// ./src/animates/animated-vue/transitions/attention-seekers/bounce.js